import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@shape-ds/components';
import { AttachedEvidenceButton } from './AttachedEvidenceButton';
import { useAnalysisButtons } from './useAnalysisButtons';

interface AnalysisButtonsProps {
  assetId: string;
}

export type AnalysisType = 'OIL_ANALYSIS' | 'VIBRATION_ANALYSIS';

export const ANALYSIS_TYPES: Array<AnalysisType> = ['OIL_ANALYSIS', 'VIBRATION_ANALYSIS'];

export const AnalysisButtons: React.FC<AnalysisButtonsProps> = ({ assetId }) => {
  const { t } = useTranslation();
  const { oilAnalysisData, vibrationAnalysisData, handleOpenModal, handleDelete } =
    useAnalysisButtons(assetId);

  return (
    <>
      {ANALYSIS_TYPES.map((type) => {
        const data = type === 'OIL_ANALYSIS' ? oilAnalysisData : vibrationAnalysisData;
        if (!data || data.length === 0) return null;
        return (
          <Tooltip title={t('case:common.preview')}>
            <AttachedEvidenceButton
              btnType={type}
              btnText={t(`monitoring:tables.tabsLabels.${type}`)}
              handleBtnClick={() => handleOpenModal(type)}
              handleBtnDelete={() => handleDelete(type)}
            />
          </Tooltip>
        );
      })}
    </>
  );
};
